import { render } from "./ViewportBackground.vue?vue&type=template&id=4d0018d8&scoped=true&ts=true"
import script from "./ViewportBackground.vue?vue&type=script&lang=ts"
export * from "./ViewportBackground.vue?vue&type=script&lang=ts"

import "./ViewportBackground.vue?vue&type=style&index=0&id=4d0018d8&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0018d8"]])

export default __exports__